// extracted by mini-css-extract-plugin
module.exports = {"root":"HomeLayout_root__1q0Lz","content":"HomeLayout_content__2avl_"};